module.exports = __webpack_public_path__ + "static/media/ID.29690cdc.webp";